const API_BASE_URL = process.env.REACT_APP_API_URL || "";

export function resolveMediaUrl(path) {
    if (!path) {
        return "";
    }

    if (/^(https?:)?\/\//.test(path) || path.startsWith("data:")) {
        return path;
    }

    const normalizedPath = path.startsWith("/") ? path : `/${path}`;

    return `${API_BASE_URL}${normalizedPath}`;
}
